export default __webpack_public_path__ + "static/media/mobile.5a0a9951.png";